import React from 'react';
import {
  PreferencesContentWrapper,
  PreferencesSection,
  PreferencesSectionDescription,
  PreferencesSectionTitle,
} from '../PreferencesUI';
import { IconWrapper, SvgIcon } from '../../../../components/Icon';
import ToggleSlackInstallButton from './ToggleSlackInstallButton';

const SlackIntegration = () => {
  return (
    <PreferencesSection>
      <PreferencesSectionTitle>
        <IconWrapper size={24}>
          <SvgIcon name="slack-logo" />
        </IconWrapper>
        Slack Integration
      </PreferencesSectionTitle>
      <PreferencesContentWrapper>
        <div>
          <ToggleSlackInstallButton />
        </div>
        <PreferencesSectionDescription>
          Integrate Kubit with Slack for seamless notifications. Receive alerts
          instantly when you’re tagged in reports or dashboards, and preview
          charts directly in Slack when you share a Kubit link.
        </PreferencesSectionDescription>
      </PreferencesContentWrapper>
    </PreferencesSection>
  );
};

export default SlackIntegration;
